import ConnectedIcon from 'assets/ConnectedIcon';
import { BaseTag } from '../../../components';
import { TagIntent } from '../../../styles';
import DisconnectedIcon from 'assets/DisconnectedIcon';
import SignalIcon from 'assets/SignalIcon';
import RoundedWarningIcon from 'assets/RoundedWarningIcon';
import DeactivatedIcon from 'assets/DeactivatedIcon';

export const ConnectedTag = () => {
  return (
    <BaseTag
      icon={ConnectedIcon}
      translationId="views.FleetSettings.Telematics.Table.Status.connected"
      intent={TagIntent.ACTIVE}
    />
  );
};

export const DisconnectedTag = () => {
  return (
    <BaseTag
      icon={DisconnectedIcon}
      translationId="views.FleetSettings.Telematics.Table.Status.disconnected"
      intent={TagIntent.DANGER}
    />
  );
};

export const ReadyToConnectTag = () => {
  return (
    <BaseTag
      icon={SignalIcon}
      translationId="views.FleetSettings.Telematics.Table.Status.readyToConnect"
      intent={TagIntent.UNKNOWN}
    />
  );
};

export const UndetectedVinTag = () => {
  return (
    <BaseTag
      icon={RoundedWarningIcon}
      translationId="views.FleetSettings.Telematics.Table.Status.undetectedVin"
      intent={TagIntent.WARNING}
    />
  );
};

export const DeactivatedTag = () => {
  return (
    <BaseTag
      icon={DeactivatedIcon}
      translationId="views.FleetSettings.Telematics.Table.Status.deactivated"
      intent={TagIntent.DISABLED}
    />
  );
};
